import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localeDe from '@angular/common/locales/de';
import {
	ApplicationConfig,
	importProvidersFrom,
	inject,
	LOCALE_ID,
	provideAppInitializer,
	provideZonelessChangeDetection
} from '@angular/core';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { PreloadAllModules, provideRouter, RouteReuseStrategy, withPreloading } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular';
import { provideTranslateService, TranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideNovaPortalLib } from '@nova-portal/frontend-lib';
import { AuthService, provideApiClient, provideNovaPortalAuth } from '@nova-portal/frontend-lib/firebase';
import { NgxPermissionsModule } from 'ngx-permissions';
import { environment } from '../environments/environment';
import { routes } from './app.routes';

registerLocaleData(localeDe, 'de');

class DynamicLocaleId extends String {
	protected readonly service = inject(TranslateService);

	public override toString(): string {
		return this.service.currentLang() ?? 'de';
	}
}

export const appConfig: ApplicationConfig = {
	providers: [
		provideZonelessChangeDetection(),
		provideAppInitializer(() => inject(AuthService).init()),
		provideNovaPortalLib(environment),
		provideApiClient(),
		provideNovaPortalAuth(),
		importProvidersFrom(NgxPermissionsModule.forRoot()),
		provideFirebaseApp(() => initializeApp(environment.firebase)),
		provideHttpClient(withInterceptorsFromDi()),
		provideRouter(routes, withPreloading(PreloadAllModules)),
		provideTranslateService({
			loader: provideTranslateHttpLoader({
				prefix: './assets/i18n/',
				suffix: `.json?v=${environment.version}`
			})
		}),
		provideIonicAngular({
			backButtonDefaultHref: '/',
			_forceStatusbarPadding: environment.forceStatusbarPadding
		}),
		{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
		{ provide: LOCALE_ID, deps: [TranslateService], useClass: DynamicLocaleId }
	]
};
